import React from "react";
import { Building2, Server, Compass, HardHat, Briefcase, Megaphone } from "lucide-react";
import { useLang } from "../../i18n";
import { Reveal, SectionHeading } from "./shared";

const META = [
  { icon: Building2, sub: { de: "Kleine & mittlere Unternehmen", en: "Small & medium enterprises" } },
  { icon: Server, sub: { de: "Software & Systemhäuser", en: "Software & system houses" } },
  { icon: Compass, sub: { de: "Ingenieur- & Planungsbüros", en: "Engineering & planning offices" } },
  { icon: HardHat, sub: { de: "Bau & Infrastruktur", en: "Construction & infrastructure" } },
  { icon: Briefcase, sub: { de: "Management & Fachberatung", en: "Management & expert advisory" } },
  { icon: Megaphone, sub: { de: "Kreativ & Digital", en: "Creative & digital" } },
];

export const TargetAudience = () => {
  const { t, lang } = useLang();
  return (
    <section className="border-t border-[var(--border)] bg-white">
      <div className="mx-auto max-w-[1180px] px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
        <Reveal><SectionHeading eyebrow={t.audience.eyebrow} title={t.audience.title} /></Reveal>
        <Reveal delay={0.05}>
          <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {t.audience.chips.map((c, i) => {
              const Icon = META[i].icon;
              return (
                <div key={c} className="group flex items-start gap-4 rounded-2xl border border-[var(--border)] bg-white p-5 shadow-md-soft transition-all duration-300 hover:-translate-y-0.5 hover:border-[var(--blue)]/25 hover:shadow-lg-soft">
                  <span className="grid h-12 w-12 shrink-0 place-items-center rounded-xl text-white shadow-md-soft transition-transform duration-300 group-hover:scale-[1.06]" style={{ background: "linear-gradient(140deg,#3b76ff,#1746c9)" }}>
                    <Icon className="h-5.5 w-5.5" strokeWidth={1.7} />
                  </span>
                  <div className="pt-0.5">
                    <div className="font-heading text-[16px] font-bold text-[var(--ink)]">{c}</div>
                    <div className="mt-0.5 text-[13px] leading-snug text-[var(--slate)]">{META[i].sub[lang] || META[i].sub.de}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
